import { isNative, openNativeLink, openLinkExternal } from './native';

export const openLinkInNewTab = (link: string): void => {
  if (isNative()) {
    openNativeLink(link);
    return;
  }
  window.open(link, '_blank');
};

export const openUrlInNewNavigator = (url: string): void => {
  if (isNative()) {
    openLinkExternal(url);
    return;
  }
  window.open(url, '_blank');
};
